import React, {useState, useEffect} from 'react'
import {TweenMax} from 'gsap'
import logo from '../images/logo-ipicim.svg';
import AppLoader from './Loader.js';

	function AnimationIni () {

	useEffect(() => {
		TweenMax.to('#gradient1', {duration:1, opacity:1})
		TweenMax.to('.chargeCircle', {duration:.5, opacity:1})
		TweenMax.to('.oneto100', {duration:1, opacity:1}, "-=.7")
		TweenMax.to('.oneto100', {duration:1, opacity:0}, "+=2")
		TweenMax.to('.chargeCircle', {duration:.5, opacity:0}, "-=.7")
		TweenMax.to('#gradient1', {duration:1, background:"linear-gradient(0deg, rgba(2,4,92,1) 0%, rgba(34,110,137,1) 50%, rgba(47,152,155,1) 100%)"}, "-=.5")
		TweenMax.to('.welcomeText', {duration:1, opacity:1}, "-=.5")
		TweenMax.to('.welcome', {duration:.5, opacity:0, height:0, margin:0}, "+=.5")
		TweenMax.to('.logoIni', {duration:.5, transform:"scale(0.8)"})
		TweenMax.to('.chargeCircle', {duration:.5, opacity:1}, "-=.5")
		TweenMax.to(".pulse", {duration:.5, opacity:1}, "-=.5")
		TweenMax.to(".pulse", {
							  scale: 1.75,
							  opacity: 0,
							  duration: 2,
							  stagger: {
							    each: 0.5,
							    repeat: 20
							  }}, "-=.5")
	})

	let [ver, setVer] = useState(true)
	function irHome(){
		setVer(ver => !ver)
	}

	return (
		<>
			{ver?<div id="gradient1" className="gradientIni1 flexCenter">
				<div className="pulse flexCenter"></div>
				<div className="pulse flexCenter"></div>
				<div className="pulse flexCenter"></div>
				<div className="pulse flexCenter"></div>
				<div className="chargeCircle flexCenter" onClick={irHome}></div>
					<span className="counter oneto100 flexCenter"><AppLoader/></span>
					<div className="welcomeText flexCenter">
						<img src={logo} className="logoIni" alt="logo" />
						<span className="welcome">Bienvenidos</span>
					</div>
			</div>:null}
		</>
	)
}

// class Titulos extends React.Component{
//   render(){
//     return <span className="welcome">{this.props.titu}</span>
//   }
// }

export default AnimationIni
